import React from 'react';
import { DateTime } from 'luxon';
import { useStateGlobalContext } from '../../contexts/GlobalContext';

const  UpcomingAppointmentDate   = ({ date }) => {
  const { officeSetting } = useStateGlobalContext();

  if (!date) return null;

  const officeTimezone = officeSetting?.facility_time_zone;
  
  // Determine the date format from office settings (Luxon format tokens: MM=month, dd=day, yyyy=year)
  const officeDateFormat = officeSetting?.date_format === 'en-US' 
    ? 'MM/dd/yyyy' 
    : officeSetting?.date_format === 'en-GB' 
      ? 'dd/MM/yyyy' 
      : 'yyyy/MM/dd';

  // Convert from UTC to office timezone and format
  const dateTime = DateTime.fromISO(date, { zone: 'UTC' });
  const convertedDate = officeTimezone ? dateTime.setZone(officeTimezone) : dateTime;
  const formattedDate = convertedDate.toFormat(officeDateFormat);

  return <>{formattedDate}</>;
};

export default UpcomingAppointmentDate;